import { CountryPicker, WrapperEntitySelector } from '@components/Inputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';

import { TextInput, Grid } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

const AddressForm = (props: IForm) => {
  const { values, mode, onCallbackChange } = props;

  const isViewMode = mode === 'view';
  if ((values.xOrganizationAddresses != null ? values.xOrganizationAddresses.size : undefined) > 0) {
    values.addressType = values.xOrganizationAddresses.getIn([0, 'addressType']);
  } else if ((values.xPersonDataAddresses != null ? values.xPersonDataAddresses.size : undefined) > 0) {
    values.addressType = values.xPersonDataAddresses.getIn([0, 'addressType']);
  }

  //#region Handlers
  const handleChangeEntitySelector = (entity, entityName, fkField) => {
    const value = entity ? entity.getID() : null;
    props.onChange(entityName, entity);
    props.onChange(fkField, value);
  };
  //#endregion

  return (
    <Grid container direction="column" spacing={1}>
      <WrapperEntitySelector
        searchComponent={generateSearchEntitySelector('addressType')}
        label={'Address type'}
        value={props.values.addressType}
        onChangeEntity={entity => handleChangeEntitySelector(entity, 'addressType', 'addressTypeId')}
        isReadOnly={isViewMode}
      />
      <TextInput isReadOnly={isViewMode} label="Line 1" value={values.line1} onChangeValue={onCallbackChange('line1')} />
      <TextInput isReadOnly={isViewMode} label="Line 2" value={values.line2} onChangeValue={onCallbackChange('line2')} />
      <TextInput isReadOnly={isViewMode} label="Line 3" value={values.line3} onChangeValue={onCallbackChange('line3')} />
      <TextInput isReadOnly={isViewMode} label="Line 4" value={values.line4} onChangeValue={onCallbackChange('line4')} />
      <TextInput isReadOnly={isViewMode} label="City" value={values.city} onChangeValue={onCallbackChange('city')} />
      <TextInput
        isReadOnly={isViewMode}
        label="Zip/Postal Code"
        value={values.zipCode}
        onChangeValue={onCallbackChange('zipCode')}
      />
      <TextInput
        isReadOnly={isViewMode}
        label="State/Province/Country"
        value={values.state}
        onChangeValue={onCallbackChange('state')}
      />
      <CountryPicker value={values.countryId} onChange={onCallbackChange('countryId')} disabled={isViewMode} />
      <TextInput
        multiline
        isReadOnly={isViewMode}
        label="Details"
        value={values.details}
        onChangeValue={onCallbackChange('details')}
      />
    </Grid>
  );
};

export default AddressForm;
